<template>
  <header
    :class="$style.root"
    v-if="page?.richText"
  >
    <h1 class="reset-heading">
      <coreTextComponent
        v-if="page?.richText"
        :string="page.richText"
        :class="$style.introduction"
      />
    </h1>
  </header>
</template>

<script lang="ts" setup>
  const props = defineProps({
    page: {
      type: Object
    }
  })
</script>

<style module>
  .root {
    composes: container from global;

    margin-bottom: var(--layout--introduction-header--margin-bottom, var(--unit--vertical));
  }

  .introduction {
    composes: font-size-x-large from global;
  }
</style>
